import { Button, Dialog, DialogActions, DialogContent, DialogTitle, MenuItem, Select, Stack } from '@mui/material'
import React, { useState } from 'react'
import { UserRole } from '../../services/api/sharedTypes/User'
import CustomTextField from '../../components/common/CustomTextField'
import { useAppDispatch } from '../../hooks/reduxHooks'
import { displayMessage } from '../../services/redux/snackbar/snackbar-actions'

interface AddUserDialogProps {
    onAddUser: (username: string, password: string, role: UserRole) => void
}

const AddUserDialog: React.FC<AddUserDialogProps> = ({ onAddUser }: AddUserDialogProps) => {
    const dispatch = useAppDispatch()

    const [isDialogOpen, setIsDialogOpen] = useState(false)
    const [password, setPassword] = useState<string>('')
    const [passwordAgain, setPasswordAgain] = useState<string>('')
    const [username, setUsername] = useState<string>('')
    const [role, setRole] = useState<UserRole>(UserRole.NotSet)

    const handleOpenDialog = () => {
        setIsDialogOpen(true)
    }

    const handleCloseDialog = () => {
        setIsDialogOpen(false)
        setPassword('')
        setPasswordAgain('')
        setUsername('')
        setRole(UserRole.NotSet)
    }

    const handleAddUser = () => {
        if (!username || !password || !passwordAgain || role === UserRole.NotSet) {
            dispatch(displayMessage({ message: 'Vyplňte všechny údaje', type: 'error' }))
            return
        }
        if (password !== passwordAgain) {
            dispatch(displayMessage({ message: 'Hesla se neshodují', type: 'error' }))
            return
        }
        onAddUser(username, password, role)
        handleCloseDialog()
    }

    return (
        <>
            <Button variant='contained' onClick={handleOpenDialog}>+ Přidat uživatele</Button>

            <Dialog open={isDialogOpen} onClose={handleCloseDialog}>
                <DialogTitle>Přidat uživatele</DialogTitle>
                <DialogContent>
                    <Stack spacing={3} pt={2} minWidth={400}>
                        <CustomTextField
                            label='Uživatelské jméno / e-mail'
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                        />
                        <CustomTextField
                            label='Heslo'
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            type='password'
                        />
                        <CustomTextField
                            label='Heslo znovu'
                            value={passwordAgain}
                            onChange={(e) => setPasswordAgain(e.target.value)}
                            type='password'
                        />
                        <Select
                            value={role}
                            onChange={(e) => setRole(e.target.value as UserRole)}
                            style={{ maxHeight: 36 }}
                        >
                            <MenuItem value={UserRole.NotSet}>Vyberte roli</MenuItem>
                            <MenuItem value={UserRole.Admin}>Admin</MenuItem>
                            <MenuItem value={UserRole.User}>Uživatel</MenuItem>
                        </Select>
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button variant='outlined' onClick={handleCloseDialog}>
                        Zrušit
                    </Button>
                    <Button onClick={handleAddUser} variant='contained' autoFocus>
                        Přidat
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default AddUserDialog